import React from 'react';
import { motion } from 'framer-motion';

export const Footer = () => {
  return (
    <footer className="bg-[#0f0f10] border-t border-[#D4AF37]/20 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-[#8B1538] to-[#A52A2A] rounded-sm flex items-center justify-center">
                <span className="text-2xl font-bold text-[#D4AF37]">IA</span>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">INDOAXIUM</h3>
                <p className="text-xs text-[#D4AF37]">WE DELIVER AS PROMISED</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-md mb-4">
              INDOAXIUM SOFTWARE SERVICES (OPC) PRIVATE LIMITED - Your trusted quality assurance partner 
              delivering excellence in software testing services.
            </p>
            <div className="text-xs text-gray-500 leading-relaxed">
              <p className="font-semibold text-[#D4AF37] mb-1">Registered Office:</p>
              <p>
                Villa No. 173, Sark Two, Mokila, Shankarpally,<br />
                Shankarpalli Rangareddy KV, Rangareddy,<br />
                Hyderabad, Telangana – 501203, India
              </p>
              <div className="mt-4 pt-3 border-t border-[#D4AF37]/10 space-y-1">
                <p><span className="text-[#D4AF37] font-semibold">CIN:</span> U62099TS2023OPC171347</p>
                <p><span className="text-[#D4AF37] font-semibold">GSTIN:</span> 36AAHCI0474N1Z7</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-400 hover:text-[#D4AF37] transition-colors duration-200 text-sm">
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-[#D4AF37] transition-colors duration-200 text-sm">
                  Contact
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors duration-200 text-sm">
                  About Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">support@axiumsolution.net</li>
              <li className="text-gray-400 text-sm">24/7 Support Available</li>
              <li className="text-gray-500 text-xs pt-2 leading-relaxed">
                <span className="text-[#D4AF37] font-semibold block mb-1">Operational Office:</span>
                S-1, D No. 402/3RT, Lane 14,<br />
                Govt City Library, S.R Nagar,<br />
                Hyderabad, Telangana – 500038
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#D4AF37]/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © 2025 INDOAXIUM SOFTWARE SERVICES. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-500 hover:text-[#D4AF37] transition-colors duration-200 text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-[#D4AF37] transition-colors duration-200 text-sm">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};